import { useActiveChatId } from "@/lib/hooks/useActiveChatId";
import { useMessageStore } from "@/state/stores";
import { type PropsWithChildren, useEffect } from "react";
import { useStickToBottom } from "use-stick-to-bottom";
import { ChatInput } from "./ChatInput";

export function ChatContainer({ children }: PropsWithChildren) {
  const isNewChat = useMessageStore((state) => state.messages.length === 0);

  const { contentRef, scrollRef, scrollToBottom } = useStickToBottom({
    initial: "instant",
  });

  const chatId = useActiveChatId();

  useEffect(() => {
    if (chatId) {
      scrollToBottom("instant");
    }
  }, [chatId, scrollToBottom]);

  return (
    <main ref={scrollRef} className="overflow-y-auto flex flex-col h-full">
      <div
        ref={contentRef}
        className="w-full max-w-2xl mx-auto px-5 pt-5 flex-1"
      >
        {children}
      </div>

      <ChatInput
        isNewChat={isNewChat && !chatId}
        onSendMessage={scrollToBottom}
      />
    </main>
  );
}
